import { Box, Typography, IconButton } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const ModalOverlay = styled(Box)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10002;
`

export const ModalContainer = styled(Box)`
  background-color: ${theme.colors.surfaceContainerBackground};
  border-radius: 12px;
  padding: 32px;
  width: 664px;
  display: flex;
  flex-direction: column;
  gap: 48px;
`

export const ModalHeader = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const ModalTitleRow = styled(Box)`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`

export const ModalTitleWrapper = styled(Box)`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 50px;
`

export const ModalTitle = styled(Typography)`
  font-family: ${theme.typography.fontFamily.primary};
  font-size: 28px;
  font-weight: 500;
  color: ${theme.colors.menuItemText};
  text-align: center;
  line-height: 42px;
`

export const CloseButton = styled(IconButton)`
  color: ${theme.colors.devicesSecondaryText};
  padding: 9px;
  width: 42px;
  height: 42px;

  &:hover {
    background-color: rgba(255, 255, 255, 0.05);
  }
`

export const ModalDescription = styled(Box)`
  font-family: ${theme.typography.fontFamily.primary};
  font-size: 14px;
  font-weight: 400;
  color: ${theme.colors.devicesSecondaryText};
  text-align: center;
  line-height: 22px;
  letter-spacing: 0.25px;
`

export const ModalContent = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 32px;
`

export const ModalActions = styled(Box)`
  display: flex;
  gap: 8px;
`
